import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import './CandidateStatusPill.css';

const ICONS = {
  consumed: 'stop_circle',
  pending: 'pause_circle',
  playing: 'play_circle',
  inconsistent: 'error',
};

const CandidateStatusPill = ({ state }) => {
  if (!ICONS[state]) return null;
  return (
    <span className={`candidate-status-pill ${state}`}>
      <span className="pill-icon material-symbols-rounded material-symbols-filled">
        {ICONS[state]}
      </span>
      {I18n.t(`campaigns.move.status.${state}`)}
    </span>
  );
};

CandidateStatusPill.propTypes = {
  state: PropTypes.string,
};

export default CandidateStatusPill;
